import React, { FC } from 'react';

import { IconProps } from 'types/components';

import CardIcon from './CardIcon';

const AmericanExpressCard: FC<IconProps> = (props) => (
  <CardIcon {...props}>
    <rect width="208" height="134" x="1" y="1" fill="#e5f1fa" rx="24" />
    <path fill="#d6dce5" d="M185 136H25a25 25 0 0 1-25-25V25A25 25 0 0 1 25 0h160a25 25 0 0 1 25 25v86a25 25 0 0 1-25 25ZM25 1A24 24 0 0 0 1 25v86a24 24 0 0 0 24 24h160a24 24 0 0 0 24-24V25a24 24 0 0 0-24-24Z" />
    <path fill="#006fcf" d="M209.08 25.26h-17.22l-9 25.83-9.39-25.83h-17.6v40.21l-18-40.21h-14.48l-18 41.09h12.52l3.52-8.22h18.78l3.53 8.22h23.47V37.78l10.57 28.57h9.78l10.56-28.57v28.57h11v6.26H194.6l-11.74 12.91-12.13-12.91H121v41.08h49.3l12.13-13.3 12.13 13.3h14.48v5.08h-17.18l-9.39-10.17-9.39 10.17h-58.3v-47H96L119.48 19h22.69l8.22 18V19h28.17l4.69 13.69L188 19h21.13Zm0 56.34L198.51 93l10.57 11.35v9.39L189.91 93l19.17-20.34Zm-53.22 32.09v-9.78h-23.47v-6.26h23.08v-9.39h-23.08V82h23.48v-9.39L175.43 93l-19.56 20.74ZM125 49.13l5.48-13.3 5.48 13.3Z" />
  </CardIcon>
);

export default AmericanExpressCard;
